import { useSelector } from 'react-redux';
import { selectSession, selectSessionAdvisor } from '../model';
import CompanyLogoContainer from './CompanyLogo';

import { SessionType } from '../../../shared/src/SessionType';
import classNames from 'classnames';
import { ContactAdvisorButton } from './ContactAdvisorButton';
import { useState } from 'react';
import { RequestAdvisorMeetingModal } from './RequestAdvisorMeetingModal';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { useAdvisorNavigation } from './AdvisorDashboardRouteGuard';
import { useNavigate } from 'react-router-dom';
import { ClientUserMenu } from './ClientUserMenu';
import { useClientSignOut } from './hooks/use-sign-out';

type TopBannerOnboardingProps = {
  className?: string;
};

export function TopBannerOnboarding({ className }: TopBannerOnboardingProps) {
  const advisor = useSelector(selectSessionAdvisor);
  const session = useSelector(selectSession);
  const { auth0Session } = session;
  const { navigateToClientsDashboard } = useAdvisorNavigation();
  const navigate = useNavigate();
  const handleSignOut = useClientSignOut();

  const navigateToClientHome = () => {
    navigate('/client/home');
  };

  const [isRequestMeetingOpen, setIsRequestMeetingOpen] = useState(false);

  return (
    <>
      <div
        className={classNames(
          'relative mb-2 flex flex-col gap-2 md:flex-row md:justify-between md:gap-0',
          className,
        )}
      >
        <div className="inline-block">
          {session.sessionType === SessionType.client ? (
            <CompanyLogoContainer
              organizationDisplayName={advisor.organizationDisplayName}
            />
          ) : (
            <CompanyLogoContainer
              organizationDisplayName={advisor.organizationDisplayName}
              onClick={() => {
                navigateToClientsDashboard();
              }}
            />
          )}
        </div>

        {session.sessionType === SessionType.client ? (
          <div className="flex items-center gap-2">
            <ContactAdvisorButton
              requestMeetingOnClick={() => setIsRequestMeetingOpen(true)}
            />
            <ClientUserMenu
              handleClickSignOut={handleSignOut}
              clientEmail={auth0Session?.clientUser?.email ?? ''}
              onNavigateHome={navigateToClientHome}
              showEmail={false}
            />
          </div>
        ) : (
          <button
            className="fixed right-4 top-4 z-50 flex shrink-0 items-center justify-center rounded-full border border-primary-100 bg-primary-50 p-1.5 text-gray-600 hover:bg-primary-100 hover:text-primary-dark md:right-16"
            onClick={() => {
              navigateToClientsDashboard();
            }}
          >
            <XMarkIcon
              className="h-6 w-6 md:h-7 md:w-7"
              strokeWidth={1}
            />
          </button>
        )}
      </div>
      <RequestAdvisorMeetingModal
        open={isRequestMeetingOpen}
        onClose={() => setIsRequestMeetingOpen(false)}
      />
    </>
  );
}
